import { backendAxios } from "../Services/axios";
import iDocument from "../models/iDocument";

export default class DocumentController {
  static async getDocumentsByName(name: string): Promise<iDocument[]> {
    const response = await backendAxios.get(`/docs/${name}`);
    return response.data;
  }
}
